import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../context/PlatformAuthContext';

const PlatformPrivateRoute = ({ children }) => {
  const { isPlatformAdmin, loading } = usePlatformAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '20px' }}>로딩중...</div>;
  }

  if (!isPlatformAdmin) {
    return (
      <Navigate
        to="/platform_admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default PlatformPrivateRoute;